import React from "react";
import { EntityEditProvider } from "@/contexts/EntityEditContext";
import type { EntityEditProviderProps } from "@/types/contexts/entityEdit";
import { InvoiceType } from "@/types/db/invoices";
import { invoiceService } from "@/services/invoiceService";

interface InvoiceEditProviderProps extends Omit<EntityEditProviderProps<InvoiceType>, "onSave" | "entityName"> {
  children: React.ReactNode;
}

export function InvoiceEditProvider({ children, entityData, loading, onSaveSuccess }: InvoiceEditProviderProps) {
  const handleSave = async (formData: Partial<InvoiceType>): Promise<InvoiceType> => {
    if (!entityData?.id) {
      throw new Error("No invoice ID available");
    }

    // Clean the data - remove read-only, joined, and extracted fields before sending to database
    const {
      id,
      created_at,
      project, // joined relation
      invoice_number, // extracted from meta_data
      invoice_date, // extracted from meta_data
      purchase_order_number, // extracted from meta_data
      amount_due, // extracted from meta_data
      line_items, // extracted from meta_data
      ...cleanFormData
    } = formData;

    const updatedInvoice = await invoiceService.updateInvoice(entityData.id, cleanFormData);
    return updatedInvoice;
  };

  return (
    <EntityEditProvider
      entityData={entityData}
      loading={loading}
      onSave={handleSave}
      onSaveSuccess={onSaveSuccess}
      entityName="Invoice"
    >
      {children}
    </EntityEditProvider>
  );
}
